<template>
  <div class="mobile-wrapper">
    <div class="fixed-banner">
      <div class="container-fluid banner-alt" :style="getStyle()">
        <div class="row">
          <div class="col-12 banner-title">
            <i class="material-icons md-36" @click="goBack">keyboard_arrow_left</i>
            <span class="title-text" @click="goBack">User Stamps</span>
          </div>
        </div>
      </div>
    </div>
    <div class="bg-white vform position-relative">
      <div class="justify-content-center">
        <div class="col-12 bg-white py-4">
          <div class="container mt-200">
            <div class="text-center">
              <div>LOYALTY STAMPS</div>
              <div>{{(dbuser.RewardPoints?dbuser.RewardPoints:0) | formatNumber}}</div>
            </div>
            <hr />
          </div>
          <div
            v-if="getFirstValidRedemptionRule"
            class="container mb-4 mt-4 justify-content-center"
          >
            <div
              class="row justify-content-center mb-4"
            >Collect {{getFirstValidRedemptionRule.Point}}, get 1 {{getFirstValidRedemptionRule.Name}} Free</div>
            <div width="300" class="row justify-content-center">
              <canvas id="circleContainer"></canvas>
              <div :style="mobileStyles.CommonColorTxt" class="inner-shape">
                <i class="fa fa-heart"></i>
              </div>
            </div>
            <div
              class="row justify-content-center mb-0"
              style="margin-top:-20px;margin-left: -25px;"
            >{{(dbuser.RewardPoints?dbuser.RewardPoints>getFirstValidRedemptionRule.Point?getFirstValidRedemptionRule.Point:dbuser.RewardPoints:0)}}/{{getFirstValidRedemptionRule.Point}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import shared from "../../sharedscripts/user/Loyalty.js";
import moment from "moment";
export default {
  data() {
    return {
      page: 2,
      perPage: 3,
      records: 0,
      options: {
        theme: "bootstrap4",
        chunksNavigation: "scroll",
        texts: {
          count: "",
          prev: "prev"
        }
      },
      orders: [],
      pageOrders: [],
      loading: false,
      error: "",
      success: false
    };
  },
  computed: {
    ...mapGetters([
      "user",
      "currentstore",
      "mobileStyles",
      "currentStoreDoc",
      "getFirstValidRedemptionRule"
    ]),
    ...shared.computed
  },
  watch: {
    user(newValue) {
      if (newValue) {
        this.initOrders(this.currentStoreDoc.ID);
      }
    }
  },
  created() {
    if (this.user) {
      this.initOrders(this.currentStoreDoc.ID);
    }
  },
  mounted() {
    this.drawCircle(this.mobileStyles.alertInfoBackGround.background);
  },
  methods: {
    goBack() {
      this.$router.push({
        name: "store",
        params: { storeid: this.currentstore }
      });
    },
    getCreateDate(order) {
      if (order.ScheduledTime)
        return moment(order.ScheduledTime.toDate()).format("lll");
    },
    getStyle() {
      var styles = [];
      styles.push(this.mobileStyles.primaryBackgroundColour);
      return styles;
    },
    ...shared.methods
  }
};
</script>

